/* @flow */

import React from 'react'

export default function Pagination(props: {
  query: {
    page: number,
    perPage: number,
  },
  length: number,
  goToPreviousPage: (event: Event) => void,
  goToNextPage: (event: Event) => void,
}) {
  const arrow = ico => ({ __html: ico })

  return (
    <div style={{ width: '100px' }}>
      <div
        className="dib tc f6 pv2 ph3 nowrap pointer gray b--gray ba mr2"
        disabled={props.query.page === 0}
        onClick={props.goToPreviousPage}
        dangerouslySetInnerHTML={arrow('&lt;')}
      />
      <div
        className="dib tc f6 pv2 ph3 nowrap pointer gray b--gray ba"
        disabled={props.length < props.query.perPage}
        onClick={props.goToNextPage}
        dangerouslySetInnerHTML={arrow('&gt;')}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Pagination.js